(function(){
  function init(root){
    if(!root || root.dataset.initialized || !window.CycoProductFit || !window.CycoGuideSizing) return;
    root.dataset.initialized="true";
    var panel=root.querySelector("[data-panel]");
    var backdrop=root.querySelector("[data-backdrop]");
    var guidePanel=root.querySelector("[data-guide-panel]");
    var guideBackdrop=root.querySelector("[data-guide-backdrop]");
    var guideOpen=root.querySelector("[data-guide-open]");
    var guideClose=root.querySelector("[data-guide-close]");
    var openButton=root.querySelector("[data-open]");
    var closeButton=root.querySelector("[data-close]");
    var input=root.querySelector("[data-measurement]");
    var slider=root.querySelector("[data-slider]");
    var error=root.querySelector("[data-error]");
    var F=window.CycoProductFit,productMeta=JSON.parse(root.querySelector("[data-sizing-product]").textContent),labels=JSON.parse(root.querySelector("[data-fit-labels]").textContent);
    var units="cm";
    var listedLengthUnit=root.dataset.listedLengthUnit==="in"?"in":"cm";
    var wristCm=16;
    var rangeMinCm=Number(root.dataset.rangeMinCm)||13;
    var rangeMaxCm=Number(root.dataset.rangeMaxCm)||26;
    var fit="comfortable";
    var activeStep=1;
    var opener=null;
    var previousBodyOverflow="";
    var lastRenderedInput="";
    var variants=[];
    try{variants=JSON.parse(root.querySelector("[data-variants]").textContent||"[]");}catch(e){variants=[];}
    document.body.appendChild(backdrop);
    document.body.appendChild(panel);
    document.body.appendChild(guideBackdrop);
    document.body.appendChild(guidePanel);

    function formatCm(value){return String(Number(value.toFixed(4)))+" cm";}
    function displayValue(value,unit){return unit==="cm"?String(Number(value.toFixed(4))):String(Number((value/2.54).toFixed(2)));}
    function showError(message){error.textContent=message;error.hidden=!message;var resultError=panel.querySelector("[data-result-error]");if(resultError){resultError.textContent=message;resultError.hidden=!message;}}
    function updateMeasureCheck(){
      var note=panel.querySelector("[data-measure-check]");
      if(!note)return;
      var sorted=widthVariants().map(function(v){return parseLength(v.length||v.title);}).filter(Number.isFinite).sort(function(a,b){return a-b;});
      note.hidden=true;if(!sorted.length)return;
      if(wristCm<sorted[0]-2.5){note.textContent="The shortest listed length may feel loose. Check the fit notes in your results.";note.hidden=false;}
      else if(wristCm>=sorted[sorted.length-1]-1e-7){note.textContent="The bracelet alone may be too short. Check the results for a compatible extension or ask us about your fit.";note.hidden=false;}
    }
    function updateField(){
      var min=units==="cm"?rangeMinCm:rangeMinCm/2.54;
      var max=units==="cm"?rangeMaxCm:rangeMaxCm/2.54;
      var current=units==="cm"?wristCm:wristCm/2.54;
      input.value=displayValue(wristCm,units);
      lastRenderedInput=String(input.value);
      input.min=min.toFixed(4);
      input.max=max.toFixed(4);
      input.step="any";
      input.setAttribute("aria-label","Wrist circumference in "+(units==="cm"?"centimetres":"inches"));
      slider.min=units==="cm"?String(rangeMinCm):String(rangeMinCm/2.54);
      slider.max=units==="cm"?String(rangeMaxCm):String(rangeMaxCm/2.54);
      slider.step=units==="cm"?"0.1":String(0.1/2.54);
      slider.value=String(current);
      slider.setAttribute("aria-label","Wrist circumference in "+(units==="cm"?"centimetres":"inches"));
      var minLabel=panel.querySelector("[data-range-min]");
      var maxLabel=panel.querySelector("[data-range-max]");
      if(minLabel)minLabel.textContent=units==="cm"?rangeMinCm+" cm":(rangeMinCm/2.54).toFixed(2)+" in";
      if(maxLabel)maxLabel.textContent=units==="cm"?rangeMaxCm+" cm":(rangeMaxCm/2.54).toFixed(2)+" in";
      var hint=panel.querySelector("[data-unit-hint]");
      if(hint)hint.textContent=units==="cm"?"Both controls show centimetres. Sizing uses your exact wrist measurement.":"Both controls show inches. We convert your exact measurement to centimetres for sizing.";
      var help=panel.querySelector("[data-measure-help]");
      if(help)help.textContent=units==="cm"?"The slider moves in 0.1 cm steps. Typed values are preserved exactly.":"The slider moves in 0.01 inch steps. Typed values are preserved and converted to centimetres.";
      panel.querySelectorAll("[data-unit]").forEach(function(button){
        button.setAttribute("aria-pressed",String(button.dataset.unit===units));
      });
      var summary=panel.querySelector("[data-measure-summary]");
      if(summary)summary.textContent=formatCm(wristCm);
      var label=panel.querySelector("[data-measure-label]");if(label)label.textContent="Wrist circumference in "+(units==="cm"?"centimetres":"inches");
      var controlLabel=panel.querySelector("[data-control-label]");if(controlLabel)controlLabel.textContent=(units==="cm"?"Number field and slider: centimetres":"Number field and slider: inches")+" · bracelet lengths: "+listedLengthUnit;
      if(help)help.textContent=units==="cm"?"Slider steps are 0.1 cm. Typed decimal measurements are preserved exactly.":"Slider steps are about 0.04 in (0.1 cm). Typed inch measurements are converted to cm without early rounding.";
      if(hint)hint.textContent=units==="cm"?(listedLengthUnit==="in"?"Centimetres selected for your wrist. This bracelet’s inch lengths are converted to centimetres for comparison.":"Centimetres selected. The finder compares your wrist with the listed bracelet lengths."):"Inches selected. Your wrist and any inch bracelet lengths are converted to centimetres for comparison.";
      updateMeasureCheck();
    }
    function readInput(){
      if(String(input.value)===lastRenderedInput){showError("");return true;}
      var entered=Number(input.value);
      var min=units==="cm"?rangeMinCm:rangeMinCm/2.54;
      var max=units==="cm"?rangeMaxCm:rangeMaxCm/2.54;
      if(!input.value || !Number.isFinite(entered) || entered<min || entered>max){
        showError(units==="cm"?"Enter a wrist measurement between "+rangeMinCm+" and "+rangeMaxCm+" cm.":"Enter a wrist measurement between "+(rangeMinCm/2.54).toFixed(2)+" and "+(rangeMaxCm/2.54).toFixed(2)+" inches.");
        return false;
      }
      wristCm=units==="cm"?entered:entered*2.54;
      lastRenderedInput=String(input.value);
      showError("");
      slider.value=String(units==="cm"?wristCm:wristCm/2.54);
      var summary=panel.querySelector("[data-measure-summary]");
      if(summary)summary.textContent=formatCm(wristCm);
      updateMeasureCheck();
      return true;
    }
    function setStep(number){
      activeStep=number;
      panel.querySelectorAll("[data-step]").forEach(function(step){step.hidden=Number(step.dataset.step)!==number;});
      panel.querySelectorAll("[data-progress]").forEach(function(mark){if(Number(mark.dataset.progress)===number)mark.setAttribute("aria-current","step");else mark.removeAttribute("aria-current");});
      var active=panel.querySelector('[data-step="'+number+'"]');
      var focus=active && (number===1?active.querySelector("[data-measurement]"):active.querySelector("h3"));if(focus&&number!==1)focus.tabIndex=-1;
      if(focus)window.setTimeout(function(){focus.focus({preventScroll:true});},30);
      var body=panel.querySelector(".cyco-sf__body");if(body)body.scrollTo(0,0);
    }
    function open(){
      opener=document.activeElement;
      previousBodyOverflow=document.body.style.overflow;
      document.body.style.overflow="hidden";
      panel.hidden=false;backdrop.hidden=false;
      panel.setAttribute("aria-hidden","false");backdrop.setAttribute("aria-hidden","false");
      setStep(1);
    }
    function closeGuide(restoreFocus){
      guidePanel.hidden=true;guideBackdrop.hidden=true;
      guidePanel.setAttribute("aria-hidden","true");guideBackdrop.setAttribute("aria-hidden","true");
      if(restoreFocus!==false && guideOpen)guideOpen.focus();
    }
    function openGuide(){
      guidePanel.hidden=false;guideBackdrop.hidden=false;
      guidePanel.setAttribute("aria-hidden","false");guideBackdrop.setAttribute("aria-hidden","false");
      guideClose.focus();
    }
    function close(){
      if(!guidePanel.hidden)closeGuide(false);
      panel.hidden=true;backdrop.hidden=true;
      panel.setAttribute("aria-hidden","true");backdrop.setAttribute("aria-hidden","true");
      document.body.style.overflow=previousBodyOverflow;
      if(opener && opener.focus)opener.focus();
    }
    function setFit(next){
      fit=next;
      panel.querySelectorAll("[data-fit]").forEach(function(button){button.setAttribute("aria-pressed",String(button.dataset.fit===fit));});
    }
    function parseLength(title){var text=String(title||""),match=text.match(/(\d+(?:\.\d+)?)\s*(cm|inches|inch|in\b|\")/i);if(!match)return null;var n=parseFloat(match[1]);return /^in|\"/.test(match[2].toLowerCase())?n*2.54:n;}
    function normalizeWidth(value){var text=String(value||"").toLowerCase().replace(/\s/g,"");var match=text.match(/(7|10|16)mm/);return match?match[1]+"mm":"";}
    function selectedId(){
      var detail=root.closest(".product-detail"),form=detail&&detail.querySelector(".js-qb-buy-buttons form"),idInput=form&&form.querySelector('input[name="id"]');
      return String((idInput&&idInput.value)||productMeta.selectedId||"");
    }
    function activeWidth(){var selected=variants.find(function(v){return String(v.id)===selectedId();});return normalizeWidth(selected&&selected.width)||normalizeWidth(root.dataset.defaultWidth);}
    function widthVariants(){var ids=new Set(F.context(productMeta,variants,selectedId()).pool.map(function(v){return String(v.id);}));return variants.filter(function(v){return ids.has(String(v.id));});}
    function claspInfo(){
      var width=activeWidth();if(!width||width!==normalizeWidth(root.dataset.claspWidth)||!root.dataset.claspVariantId)return null;
      var color=root.dataset.claspColor||"",colour=color.charAt(0).toUpperCase()+color.slice(1);
      return {id:root.dataset.claspVariantId,width:width,color:colour,available:root.dataset.claspAvailable==="true",image:root.dataset.claspImage,title:width+" / "+colour,price:root.dataset.freeClasp==="true"?labels.free_clasp:root.dataset.claspPrice};
    }
    function calculate(){
      if(!readInput())return;
      var result=panel.querySelector("[data-result]"),apply=panel.querySelector("[data-apply]"),applyNote=panel.querySelector("[data-apply-note]"),clasp=claspInfo();
      apply.hidden=true;apply.disabled=false;delete apply.dataset.claspVariantId;delete apply.dataset.variantId;delete apply.dataset.requiresExtension;if(applyNote)applyNote.hidden=true;
      var recommendation=F.recommend(productMeta,variants,selectedId(),wristCm,fit,clasp);
      F.render(result,recommendation,{labels:labels,wrist:wristCm,format:formatCm,clasp:clasp,contactUrl:((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"pages/contact-us",onChange:function(candidate,includeClasp){
        apply.hidden=!candidate;if(applyNote)applyNote.hidden=!candidate;if(!candidate)return;
        var original=variants.find(function(v){return String(v.id)===candidate.id;});
        apply.dataset.variantId=candidate.id;apply.dataset.variantTitle=original&&original.title||"";apply.dataset.requiresExtension=String(Boolean(candidate.requiresExtension));
        if(clasp)apply.dataset.claspVariantId=clasp.id;
        apply.textContent=includeClasp?"Add bracelet + clasp to cart":labels.choose_size.replace('{length}',formatCm(candidate.cm));
        if(applyNote)applyNote.textContent=includeClasp?labels.adds_both:labels.selects_size;
      }});
      setStep(3);
    }
    async function applySize(){
      var applyButton=panel.querySelector("[data-apply]");
      var variantId=String(applyButton.dataset.variantId||"");
      var claspChoice=panel.querySelector("[data-clasp-choice]");
      if(!F.canApply(productMeta,variants,selectedId(),variantId)){calculate();showError("Your selected finish or length has changed. Check these updated options.");return;}
      if(applyButton.dataset.requiresExtension==="true"&&(!claspChoice||!claspChoice.checked)){showError(labels.clasp_required);return;}
      if(claspChoice&&claspChoice.checked){
        var claspId=String(applyButton.dataset.claspVariantId||"");
        if(!variantId||!claspId||root.dataset.claspAvailable!=="true"){showError("The selected bracelet or extension clasp is unavailable. Please choose the bracelet size without the clasp.");return;}
        applyButton.disabled=true;applyButton.textContent="Adding both to your cart…";
        try{
          var routes=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/";
          var response=await fetch(routes+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:[{id:Number(variantId),quantity:1},{id:Number(claspId),quantity:1}]})});
          var payload=await response.json();
          if(!response.ok)throw new Error(payload.description||"Please try again.");
          var cartStateResponse=await fetch(routes+"cart.js",{headers:{"Accept":"application/json"}});if(cartStateResponse.ok){var cartState=await cartStateResponse.json();document.querySelectorAll(".header-cart__count").forEach(function(count){count.textContent=cartState.item_count;});}applyButton.disabled=true;applyButton.textContent="Added to cart";close();var cartToast=root.querySelector("[data-cart-toast]");if(cartToast){cartToast.hidden=false;window.setTimeout(function(){cartToast.hidden=true;},7000);}
        }catch(err){applyButton.disabled=false;applyButton.textContent="Add bracelet + clasp to cart";showError("We couldn’t add both items. "+(err.message||"Please try again."));}
        return;
      }
      var picker=root.closest(".product-detail") && root.closest(".product-detail").querySelector("variant-picker");
      if(!variantId||!picker){showError("We couldn’t find the product size selector. Please select your size there.");return;}
      var target=variants.find(function(v){return String(v.id)===variantId;});
      var optionGroups=Array.from(picker.querySelectorAll(".option-selector[data-index]"));
      var applied=false;
      if(target&&Array.isArray(target.options)&&optionGroups.length===target.options.length){
        applied=true;
        target.options.forEach(function(value,index){
          var group=picker.querySelector('.option-selector[data-index="'+(index+1)+'"]');
          if(!group){applied=false;return;}
          var expected=String(value),radio=Array.from(group.querySelectorAll(".js-option")).find(function(el){return String(el.value)===expected;});
          if(radio){if(!radio.checked){radio.checked=true;radio.dispatchEvent(new Event("change",{bubbles:true}));}return;}
          var select=group.querySelector("select");
          if(select){if(String(select.value)!==expected){select.value=expected;select.dispatchEvent(new Event("change",{bubbles:true}));}return;}
          var listOption=Array.from(group.querySelectorAll(".custom-select__option")).find(function(el){return String(el.dataset.value||"").trim()===expected;});
          if(listOption){listOption.click();return;}
          applied=false;
        });
      }else{
        var option=picker.querySelector('.js-option[data-variant-id="'+variantId+'"]');
        if(!option)option=picker.querySelector('.js-option[value="'+(panel.querySelector("[data-apply]").dataset.variantTitle||"").replace(/"/g,'\\"')+'"]');
        if(option&&option.matches("input")){option.checked=true;option.dispatchEvent(new Event("change",{bubbles:true}));applied=true;}
        else{var listOption=picker.querySelector('.custom-select__option[data-variant-id="'+variantId+'"]');if(listOption)listOption.click();applied=Boolean(listOption);}
      }
      await new Promise(function(resolve){window.setTimeout(resolve,650);});
      var productForm=root.closest(".product-detail").querySelector(".js-qb-buy-buttons form"),selectedInput=productForm&&productForm.querySelector('input[name="id"]');
      if(!applied||!selectedInput||String(selectedInput.value)!==variantId){showError("We couldn’t apply that exact length to the product options. Please select it in the size selector.");return;}
        close();
      var pickerBox=picker.closest(".product-detail__options")||picker;
      pickerBox.scrollIntoView({behavior:window.matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth",block:"center"});
    }

    openButton.addEventListener("click",open);
    closeButton.addEventListener("click",close);
    backdrop.addEventListener("click",close);
    guideOpen.addEventListener("click",openGuide);
    guideClose.addEventListener("click",function(){closeGuide(true);});
    guideBackdrop.addEventListener("click",function(){closeGuide(true);});
    guidePanel.addEventListener("keydown",function(event){
      if(event.key==="Escape"){event.preventDefault();event.stopPropagation();closeGuide(true);return;}
      if(event.key!=="Tab")return;
      var controls=Array.from(guidePanel.querySelectorAll('button:not([disabled]),a[href]')).filter(function(el){return el.offsetParent!==null;});
      if(!controls.length)return;
      var first=controls[0],last=controls[controls.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });
    panel.querySelectorAll("[data-unit]").forEach(function(button){button.addEventListener("click",function(){if(!readInput())return;units=button.dataset.unit;updateField();});});
    input.addEventListener("input",readInput);
    input.addEventListener("change",readInput);
    slider.addEventListener("input",function(){wristCm=units==="cm"?Number(slider.value):Number(slider.value)*2.54;input.value=displayValue(wristCm,units);lastRenderedInput=String(input.value);showError("");var summary=panel.querySelector("[data-measure-summary]");if(summary)summary.textContent=formatCm(wristCm);updateMeasureCheck();});
    panel.querySelector('[data-next-step="2"]').addEventListener("click",function(){if(readInput())setStep(2);});
    panel.querySelectorAll("[data-fit]").forEach(function(button){button.addEventListener("click",function(){setFit(button.dataset.fit);});});
    panel.querySelector("[data-calculate]").addEventListener("click",calculate);
    panel.querySelectorAll("[data-back-step]").forEach(function(button){button.addEventListener("click",function(){setStep(Number(button.dataset.backStep));});});
    panel.querySelector("[data-restart]").addEventListener("click",function(){setStep(1);});
    panel.querySelector("[data-apply]").addEventListener("click",applySize);
    panel.addEventListener("keydown",function(event){
      if(event.key==="Escape"){event.preventDefault();close();return;}
      if(event.key!=="Tab")return;
      var controls=Array.from(panel.querySelectorAll('button:not([disabled]):not([hidden]),input:not([disabled]):not([hidden]),a[href]')).filter(function(el){return el.offsetParent!==null;});
      if(!controls.length)return;
      var first=controls[0],last=controls[controls.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });
    updateField();
  }
  var finderObserver=null;
  function start(){
    document.querySelectorAll("[data-cyco-sf]:not([data-initialized])").forEach(init);
    if(!finderObserver && document.body && window.MutationObserver){
      finderObserver=new MutationObserver(function(){document.querySelectorAll("[data-cyco-sf]:not([data-initialized])").forEach(init);});
      finderObserver.observe(document.body,{childList:true,subtree:true});
    }
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start);else start();
})();
